import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobileOnly } from "react-device-detect";

import { Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions } from '../actions';
import { SwitchAccount, TitleBar, DownloadApp } from  '../components'

class SwitchAccountScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderDownloadAppSection = () => {
    return <DownloadApp />
  }

  renderContentContainers = () => {
    return <div className="flex-container screen-main-content">
        <div className="flex-container-column" style={{ alignItems: 'center', marginTop: 20 }}>
          <SwitchAccount
            userActions={this.props.userActions}
            userRoles={this.props.user.roles}
            userPractices={this.props.user.practices}
            contextActions={this.props.contextActions}
          />
        </div>
      </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar userActions={this.props.userActions} practice={this.props.practice.practice} />
        { this.renderContentContainers() }
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SwitchAccountScreen)
